import { GetterTree } from 'vuex'

import { RootState } from '../types'
import { UserState } from './types'

const getters: GetterTree<UserState, RootState> = {
  user: (state: UserState) => state.data.user,

  signedIn: (state: UserState) => !!state.data.user,

  isAdmin: (state: UserState) => state.data.user && state.data.user.admin,

  loading: (state: UserState) => state.data.loading
}

export default getters
